import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0f70c1a4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "freight-container",
  id: "freight-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "dis-space-4 me-max-title"
}, "数字货运", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "info dis-space-2 me-main-title"
}, "服务5000+客户，百万平台注册司机信赖选择", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "me-top-lg"
}, " AIoT多技术场景深度融合，重塑大宗商品货运行业价值", -1));
const _hoisted_5 = {
  class: "scene-card me-top-lg"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "station-adv-line"
}, null, -1));
const _hoisted_9 = {
  class: "content"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "me-top-lg"
}, " 业务流程 ", -1));
const _hoisted_11 = {
  class: "top-card"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "bottom-card"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "font_family icon-huoyuanfabu"
}, null, -1));
const _hoisted_15 = {
  class: "col-1"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "font_family icon-yunlizuzhi"
}, null, -1));
const _hoisted_17 = {
  class: "col-1"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "font_family icon-yundanguanli"
}, null, -1));
const _hoisted_19 = {
  class: "col-1"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "font_family icon-jiesuanduizhang"
}, null, -1));
const _hoisted_21 = {
  class: "col-1"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "font_family icon-zhifuwanshui me-content-lg"
}, null, -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "dis-space-3"
}, "产品功能", -1));
const _hoisted_24 = {
  class: "project-content me-top"
};
const _hoisted_25 = {
  class: "left"
};
const _hoisted_26 = ["onMouseenter"];
const _hoisted_27 = {
  class: "item-info"
};
const _hoisted_28 = {
  class: "dis-space-1 me-sub-title"
};
const _hoisted_29 = {
  class: "me-content"
};
const _hoisted_30 = {
  class: "right"
};
const _hoisted_31 = {
  class: "project-img-panel"
};
const _hoisted_32 = ["src"];
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "dis-space-3"
}, "咨询反馈中心", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = _resolveComponent("a-button");
  const _component_SwapRightOutlined = _resolveComponent("SwapRightOutlined");
  const _component_ReferenceTable1 = _resolveComponent("ReferenceTable1");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_ReferenceTable2 = _resolveComponent("ReferenceTable2");
  const _component_ReferenceInfo1 = _resolveComponent("ReferenceInfo1");
  const _component_ReferenceInfo2 = _resolveComponent("ReferenceInfo2");
  const _component_ReferenceInfo3 = _resolveComponent("ReferenceInfo3");
  const _component_ComplaintInfo = _resolveComponent("ComplaintInfo");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_Cooperation = _resolveComponent("Cooperation");
  const _component_ConsultModal = _resolveComponent("ConsultModal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "banner-box",
    style: _normalizeStyle({
      height: _ctx.bannerHeight
    })
  }, [_createElementVNode("div", {
    class: "banner-info",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_hoisted_2, _hoisted_3, _createVNode(_component_a_button, {
    class: "service me-content",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.openConsultModdal())
  }, {
    default: _withCtx(() => [_createTextVNode("立即咨询")]),
    _: 1
  })], 4)], 4), _createElementVNode("div", {
    class: "scene-content me-pd-bottom-lg",
    style: _normalizeStyle({
      height: _ctx.bannerHeight,
      padding: _ctx.boxPadding
    })
  }, [_hoisted_4, _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sceneCardList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "card-item",
      key: index
    }, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_6), _createElementVNode("label", _hoisted_7, [_createTextVNode(_toDisplayString(item.title), 1), _hoisted_8]), _createElementVNode("span", _hoisted_9, _toDisplayString(item.content), 1)]);
  }), 128))])], 4), _createElementVNode("div", {
    class: "business-flow",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_hoisted_10, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
    src: _ctx.currentImg,
    alt: ""
  }, null, 8, _hoisted_12)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
    class: "col-4",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.clickLink(0))
  }, [_createElementVNode("div", {
    class: _normalizeClass([_ctx.currentIndex === 0 ? 'active-bottom-card-item' : '', 'bottom-card-item'])
  }, [_hoisted_14, _createTextVNode("货源发布")], 2)]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_SwapRightOutlined)]), _createElementVNode("div", {
    class: "col-4",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.clickLink(1))
  }, [_createElementVNode("div", {
    class: _normalizeClass([_ctx.currentIndex === 1 ? 'active-bottom-card-item' : '', 'bottom-card-item'])
  }, [_hoisted_16, _createTextVNode("运力组织")], 2)]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_SwapRightOutlined)]), _createElementVNode("div", {
    class: "col-4",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.clickLink(2))
  }, [_createElementVNode("div", {
    class: _normalizeClass([_ctx.currentIndex === 2 ? 'active-bottom-card-item' : '', 'bottom-card-item'])
  }, [_hoisted_18, _createTextVNode(" 运单管理")], 2)]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_SwapRightOutlined)]), _createElementVNode("div", {
    class: "col-4",
    onClick: _cache[4] || (_cache[4] = $event => _ctx.clickLink(3))
  }, [_createElementVNode("div", {
    class: _normalizeClass([_ctx.currentIndex === 3 ? 'active-bottom-card-item' : '', 'bottom-card-item'])
  }, [_hoisted_20, _createTextVNode("结算对账")], 2)]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_SwapRightOutlined)]), _createElementVNode("div", {
    class: "col-4",
    onClick: _cache[5] || (_cache[5] = $event => _ctx.clickLink(4))
  }, [_createElementVNode("div", {
    class: _normalizeClass([_ctx.currentIndex === 4 ? 'active-bottom-card-item' : '', 'bottom-card-item'])
  }, [_hoisted_22, _createTextVNode(" 支付完税 ")], 2)])])])], 4), _createElementVNode("div", {
    class: "product-info me-pd-bottom-lg",
    style: _normalizeStyle({
      height: _ctx.height,
      padding: _ctx.boxPadding
    })
  }, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productInfoList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["left-item", {
        'left-item-active': item.active
      }]),
      key: index,
      onMouseenter: $event => _ctx.productInfoMouseHandle(item)
    }, [_createElementVNode("span", _hoisted_27, [_createElementVNode("label", _hoisted_28, _toDisplayString(item.title), 1), _createElementVNode("label", _hoisted_29, _toDisplayString(item.name), 1)])], 42, _hoisted_26);
  }), 128))]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("img", {
    src: _ctx.productInfoRightImg
  }, null, 8, _hoisted_32)])])])], 4), _createElementVNode("div", {
    class: "reference-center me-pd-bottom-lg",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_hoisted_33, _createVNode(_component_a_tabs, {
    activeKey: _ctx.activeKey,
    "onUpdate:activeKey": _cache[6] || (_cache[6] = $event => _ctx.activeKey = $event),
    centered: "",
    class: "me-top",
    tabBarGutter: 30,
    tabPosition: "top",
    animated: {
      tabPane: true
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
      key: "1",
      tab: "评价公示",
      class: "me-content"
    }, {
      default: _withCtx(() => [_createVNode(_component_ReferenceTable1)]),
      _: 1
    }), _createVNode(_component_a_tab_pane, {
      key: "2",
      tab: "投诉公示",
      class: "me-content"
    }, {
      default: _withCtx(() => [_createVNode(_component_ReferenceTable2)]),
      _: 1
    }), _createVNode(_component_a_tab_pane, {
      key: "3",
      tab: "咨询投诉处理机制",
      "force-render": "",
      class: "me-content"
    }, {
      default: _withCtx(() => [_createVNode(_component_ReferenceInfo1)]),
      _: 1
    }), _createVNode(_component_a_tab_pane, {
      key: "4",
      tab: "客户准入退出机制",
      class: "me-content"
    }, {
      default: _withCtx(() => [_createVNode(_component_ReferenceInfo2)]),
      _: 1
    }), _createVNode(_component_a_tab_pane, {
      key: "5",
      tab: "用户信用评价机制",
      class: "me-content"
    }, {
      default: _withCtx(() => [_createVNode(_component_ReferenceInfo3)]),
      _: 1
    }), _createVNode(_component_a_tab_pane, {
      key: "6",
      tab: "投诉处理满意率",
      class: "me-content"
    }, {
      default: _withCtx(() => [_createVNode(_component_ComplaintInfo)]),
      _: 1
    })]),
    _: 1
  }, 8, ["activeKey"])], 4), _createVNode(_component_Cooperation, {
    title: "数字货运",
    buttonTxt: "申请试用",
    style: {
      "background-color": "#f0f2f5"
    },
    onOpenConsultModdal: _ctx.openConsultModdal
  }, null, 8, ["onOpenConsultModdal"]), _createVNode(_component_ConsultModal, {
    ref: "consultModalRef"
  }, null, 512)]);
}